import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

function CreateBuying() {

    const navigate = useNavigate();

    const [row, setRow] = useState([{ product: "", quantity: 0, price: 0, buyingGst: 0, total: 0 }]);

    const addRow = () => {
        let newRow = [...row, { product: "", quantity: 0, price: 0, buyingGst: 0, total: 0 }];
        setRow(newRow);
    }

    const removeRow = () => {
        let temp = row.slice(0, row.length - 1);
        setRow(temp);
    }

    const [products, setProducts] = useState();
    const getAllProducts = async () => {
        try {
            const response = await axios.get("/product/get/all");
            if (response.data.success) {
                setProducts(response.data.products)
            }
        } catch (error) {
            toast.error(error.response.data.message)
        }
    }

    useEffect(() => {
        getAllProducts();
    }, [])


    const calculateTotalPrice = (price, quantity, gst) => {
        let totalPrice = (price * quantity);
        let percent = totalPrice * (gst / 100);
        totalPrice = totalPrice + percent;
        return totalPrice;
    }

    const handleChange = (index, key, value) => {
        let temp = [...row];
        temp[index][key] = value;
        setRow(temp);

        if (row[index].quantity && row[index].price && row[index].buyingGst) {
            let temp = [...row];
            temp[index].total = calculateTotalPrice(row[index].price, row[index].quantity, row[index].buyingGst)
        }

        setRow(temp);

    }

    const handleSubmit = async (e) => {
        e.preventDefault();

        let formData = new FormData(e.target);
        let data = Object.fromEntries(formData.entries());

        console.log(data)

        let distributor = {
            name: data.name,
            contact: data.contact,
            address: data.address,
        }

        let products = row;

        let postData = {
            distributor,
            products,
            paymentMethod: data.paymentMethod,
            date: data.Date,
        }

        try {
            const response = await axios.post("/buy/create", postData);
            if (response.data.success) {
                toast.success(response.data.message);
                navigate("/buying");
            }
        } catch (error) {
            toast.error(error.response.data.message);
        }
    }



    return (
        <>
            <div className='border'>

                <div>
                    <h1 className='m-5 text-3xl font-bold' >Distributer Details</h1>
                    <form onSubmit={handleSubmit} className='font-bold space-y-3'>
                        <div className='ml-5 mt-5'>
                            <label htmlFor="date" className='m-2 p-2'>Date:</label>
                            <input id='date' type="date" name='Date' className='input input-bordered input-primary' required />
                        </div>
                        <label className='m-2 p-2'> Name : </label>
                        <input className='input input-bordered input-primary' type="text" name='name' placeholder='Enter Name' /> <br />

                        <label className='m-2'>Contact : </label>
                        <input className='input input-bordered input-primary' type="tel" name='contact' placeholder='ph no' /> <br />

                        <label className='m-2'>Address : </label>
                        <input className='input input-bordered input-primary' type="text" name='address' placeholder='address' /> <br />

                        <label className='m-2'>Payment Method : </label>
                        <select name='paymentMethod' className="select select-primary w-full max-w-xs">
                            <option selected>Select Payment Method</option>
                            <option value="UPI">UPI</option>
                            <option value="CARD">CARD</option>
                            <option value="NEFT">NEFT</option>
                            <option value="CASH">CASH</option>
                        </select>

                        <div>
                            <h1 className='mt-10 font-extrabold p-3 bg-orange-300'>PRODUCTS : </h1>
                            <table className="w-[70%] bg-white border mx-10 my-4">
                                <thead>
                                    <tr className='p-3'>
                                        <th className="px-4 py-2 border ">Product Name</th>
                                        <th className="px-4 py-2 border">Quantity</th>
                                        <th className="px-4 py-2 border">Purchasing Price</th>
                                        <th className="px-4 py-2 border">GST</th>
                                        <th className="px-4 py-2 border">Total </th>
                                        <th></th>
                                        <th></th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {
                                        row.map((r, i) => {
                                            return (
                                                <>
                                                    <tr>
                                                        <td className='p-2'>
                                                            <select onChange={(e) => handleChange(i, "product", e.target.value)} className="select select-primary w-full">
                                                                <option selected>Select Product</option>
                                                                {products?.map((p, i) => {
                                                                    return (
                                                                        <>
                                                                            <option value={p?._id}>{p?.name}</option>
                                                                        </>
                                                                    )
                                                                })}
                                                            </select>
                                                        </td>
                                                        <td className='p-2'>
                                                            <input onChange={(e) => handleChange(i, "quantity", e.target.value)} type="number" placeholder="Quantity"
                                                                name='quantity' className="input input-bordered input-info w-full max-w-xs" />
                                                        </td>
                                                        <td className='p-2'>
                                                            <input onChange={(e) => handleChange(i, "price", e.target.value)} type="number" placeholder="Price"
                                                                name='price' className="input input-bordered input-info w-full max-w-xs" />
                                                        </td>
                                                        <td className='p-2'>
                                                            <input onChange={(e) => handleChange(i, "buyingGst", e.target.value)} type="number" placeholder="In %"
                                                                name='buyingGst' className="input input-bordered input-info w-full max-w-xs" />
                                                        </td>
                                                        <td className='p-2'>
                                                            <input onChange={(e) => handleChange(i, "total", e.target.value)} type="text" value={r?.total} disabled
                                                                name='total' className="input input-bordered input-info w-full max-w-xs" />
                                                        </td>

                                                        {
                                                            row.length - 1 === i
                                                            &&
                                                            <td className='p-2'>
                                                                <button onClick={addRow} type='button' className="btn btn-outline btn-primary text-3xl">+</button>
                                                            </td>
                                                        }

                                                        {
                                                            row.length - 1 === i
                                                            &&
                                                            <td className='p-2'>
                                                                <button onClick={removeRow} type='button' className="btn btn-outline btn-primary text-3xl">-</button>
                                                            </td>
                                                        }

                                                    </tr>
                                                </>
                                            )
                                        })
                                    }

                                </tbody>

                            </table>
                        </div>

                        <div className='ml-10 mb-2'>
                            <button type='submit' className="btn btn-outline btn-primary font-bold" >Submit</button>
                        </div>
                    </form>
                </div>
            </div>
        </>
    )
}

export default CreateBuying
